<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getList,
  add,
  del,
  update,
  getDetails
} from "@/api/system/financialZoning";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
export default {
  name: "financialZoning",

  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getList,
        getDetails,
        del,
        add,
        update,
        getCountry
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "city_name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  type: "number",
                  message: "city_code cannot be empty",
                  trigger: "blur"
                }
              ],
              country: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ name: 24 }, , { code: 24 }, { country: 24 }],
          fields: [
            {
              name: () => this.$t("partitionName"),
              key: "name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("partitionName");
              }
            },
            {
              name: () => this.$t("partitionCode"),
              key: "code",
              component: "InputNumber",
              bind: {
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("partitionCode");
              }
            },
            {
              name: () => this.$t("countryCode"),
              key: "country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryCode");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          // {
          //   key: "remote_regions",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("remote_regions");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('YES'), value: 1 },
          //     { label: this.$t('NO'), value: 0 }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "status",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("exlType");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('enable'), value: "ENABLE" },
          //     { label: this.$t('disable'), value: "DISABLE" }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 647
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("countryCode"),
          key: "country",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$t("partitionName"),
          key: "name",
          minWidth: 100
        },
        {
          name: () => this.$t("partitionCode"),
          key: "code",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 100
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 646
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error"
              },
              id: 645
            }
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "country")
        item.options = (await getCountry()).data.payload.rows;
    });
  }
};
</script>
